import { GisRequest } from './gis.request';
import { GisOutstandingItemRequestType } from './gis.outstanding.item.request.type';

export class GisOutstandingItemRequest extends GisRequest {
  public RequestType: GisOutstandingItemRequestType;
  public HistoryMonthsFilter: number;
}
